export const TEST_ID = 'cartPanel';
